<template>
  <b-card class="RwvArtilceTile mb-2" :img-src="article.previewImage" img-left>
    <b-card-title>
      <b-link :to="{name: 'article', params: { slug: article.slug }}">{{article.title}}</b-link>
    </b-card-title>

    <b-card-text>
      {{article.subtitle}}
    </b-card-text>

    <b-card-text>
      {{article.excerpt}}
    </b-card-text>

    <!-- <router-link class="card-link" :to="{name: 'article', params: { slug: article.slug }}">
      <b-img-lazy :src="article.previewImage" :title="article.title" :alt="article.title"/>
      {{article.title}}

    </router-link> -->
    <!-- <b-link :to="{name: 'article', params: { slug: article.slug }}" class="card-link">Zum Artikel</b-link> -->
  </b-card>
</template>

<script>
export default {
  name: "RwvArtilceTile",
  props: {
    article: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.RwvArticleTile {
  width: 100%;
  float: left;
  display: block;
  overflow: hidden;
}
  .card {
    @media screen and (max-width: $screen-sm-min) {
      display: block
    }
  }
  .card-img-left {
    max-width: 200px;
    max-height: 275px;
    width: 100%;
    height: 100%;
    margin: auto;
  }
</style>
